import imageCompression from 'browser-image-compression';
import { v4 as uuidv4 } from 'uuid';

const MAX_FILE_SIZE_MB = 25;
const MAX_DIMENSION = 1920;
const ONE_MB_IN_BYTES = 1024 * 1024;

export const compressAndResizeImage = async (file: File) => {
  const fileSizeMB = file.size / ONE_MB_IN_BYTES;

  const isFileDoNotNeedCompression = fileSizeMB <= MAX_FILE_SIZE_MB;

  if (isFileDoNotNeedCompression) {
    return {
      id: uuidv4(),
      file,
    };
  }

  const compressionOptions = {
    maxSizeMB: MAX_FILE_SIZE_MB,
    maxWidthOrHeight: MAX_DIMENSION,
    useWebWorker: true,
    initialQuality: 1,
    alwaysKeepResolution: false,
    preserveExif: false,
  };

  const compressedFile = await imageCompression(file, compressionOptions);

  return {
    id: uuidv4(),
    file: compressedFile as File,
  };
};
